'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpArticleDetailMain = /** @class */function () {
    function HelpArticleDetailMain() {
        this.articleDom = document.getElementById('article');
        this.init();
    }
    HelpArticleDetailMain.prototype.init = function () {
        this.handleDownload();
        this.handleTurnPage();
        this.createAppQrcode();
        this.coverEvent();
    };
    HelpArticleDetailMain.prototype.handleDownload = function () {
        var that = this;
        var downloadDom = _tool2.default.$_selectAll(that.articleDom, '.recommend-download');
        downloadDom.forEach(function (item) {
            item.addEventListener('click', function (e) {
                if (!item.classList.contains('active')) {
                    downloadDom.forEach(function (dItem) {
                        return dItem.classList.remove('active');
                    });
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
                e.stopPropagation();
            });
        });
        document.addEventListener('click', function () {
            downloadDom.forEach(function (dItem) {
                return dItem.classList.remove('active');
            });
        });
    };
    HelpArticleDetailMain.prototype.handleTurnPage = function () {
        var that = this;
        var previousDom = _tool2.default.$_select(that.articleDom, ".previous");
        var nextDom = _tool2.default.$_select(that.articleDom, ".next");
        previousDom.addEventListener('mouseenter', function () {
            previousDom.classList.add('active');
        });
        previousDom.addEventListener('mouseleave', function () {
            previousDom.classList.remove('active');
        });
        nextDom.addEventListener('mouseenter', function () {
            nextDom.classList.add('active');
        });
        nextDom.addEventListener('mouseleave', function () {
            nextDom.classList.remove('active');
        });
    };
    //循环生成app下载二维码
    HelpArticleDetailMain.prototype.createAppQrcode = function () {
        var that = this;
        var appCodeListDom = _tool2.default.$_selectAll(that.articleDom, '.qr-code-img');
        appCodeListDom.forEach(function (item) {
            var _val = item.getAttribute('data-dUrl');
            createQrcode(item, _val);
        });
    };
    // 修改video封面
    HelpArticleDetailMain.prototype.coverEvent = function () {
        var videoDom = document.querySelectorAll('video');
        videoDom.forEach(function (item) {
            item.poster = "https://res.callmysoft.com/wm-static-resource/index/KingshiperMobile/public/img/fmImg.png";
        });
    };
    return HelpArticleDetailMain;
}();
exports.default = HelpArticleDetailMain;